module.exports = __webpack_public_path__ + "static/media/app-screenshot-1.aa13ccb0.png";